import setCookie from './setCookie'

export default isCollection => {
  const cookie = 'fulfilmentTab'
  const data = isCollection ? 'collection' : 'delivery'
  setCookie(cookie, data)
}
